export default __webpack_public_path__ + "static/media/weibo-circle.47f5e8bb.svg";